<template>
    <div class="detail-container">
        <div class="close-btn" @click="closeBefore">
            <i class="el-icon-close font-com" />
        </div>
        <div class="font-com">
            {{ info.name || '线路名称' }}
            <label v-if="info.vrinfo" class="cursor-pointer margin-left-sm" @click="checkVRView">[ 查看全景 ]</label>
        </div>
        <div class="margin-top-md border-radius-sm overflow-hidden" v-if="info.pictureList && info.pictureList.length">
            <el-carousel trigger="click" height="180px">
                <el-carousel-item v-for="item in info.pictureList" :key="item">
                    <el-image :src="item" class="width-all height-all" fit="cover" :preview-src-list="info.pictureList" />
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="margin-top-md" v-if="info.remark" style="text-indent: 2em;">
            {{ info.remark }}
        </div>
        <div class="margin-top-md">具体位置：{{ info.address || '-' }}</div>
    </div>
</template>
<script>
	export default {
        props: {
			info: {
				type: Object,
				default: {}
			},
		},
		data() {
			return {
                detailInfo: {}
            }
        },
        methods: {
            closeBefore(){
                this.$emit("closeBefore")
            },
            checkVRView(){
                window.open(`${window.location.origin}/view?id=${this.info.id}`)
            }
        }
    }
</script>
<style scoped lang="scss">
    .detail-container{
		width: 280px;
		z-index: 924;
		background-color: rgba(15, 88, 181, 0.3);
		backdrop-filter: blur(8px);
		border-radius: 5px;
		transition: 300ms;
		color: #FFF;
		text-align: left;
		font-size: 14px;
		padding: 10px 15px;
	}
    .close-btn{
        position: absolute;
        right: 15px;
        top: 15px;
        z-index: 1001;
        cursor: pointer;
    }
    .tag-box{
        gap: 10px;
    }
    .tag-card{
        border: 1px solid #FFF;
        border-radius: 5px;
        padding: 0 10px;
    }
</style>